import {
  ENTRANCE_EXAMS_ROUTE_PATH,
  hasCompletedVisibleNotificationApplications,
  hasVisibleApplicationTypes,
  isEducationTypeVisible,
  isNotificationEducationTypeVisible,
} from "../../../../core/constants/admissionDomainConfig";
import { Link } from "../interfaces/link";
import store from "../../../../store/store";

const hasExams = (exams: { "1"?: unknown[]; "2"?: unknown[] } | null): boolean =>
  !!((exams?.["1"]?.length ?? 0) + (exams?.["2"]?.length ?? 0));

const getLinks = (): Link[] => {
  const state = store.getState();
  const examsExist = hasExams(state.modulesState.notificationsState.exams);

  return [
    {
      path: "/profile",
      text: "Профиль",
      hide: !state.coreState.accountState.token,
      subgroups: [
        {
          links: [
            {
              path: state.coreState.accountState.user?.hasProfile ? "/profile/preview" : "/profile",
              text: "Личные данные",
              hide: state.coreState.accountState.ss === "1",
            },
            {
              path: "/profile/signature",
              text: "Электронная подпись",
              hide: !state.coreState.accountState.hasCompletedHighEducationApplications,
            },
          ],
        },
      ],
    },
    {
      path: "/applications",
      text: "Заявления",
      isDisabled: !state.coreState.accountState?.user?.hasProfile,
      hide:
        !state.coreState.accountState.token ||
        state.coreState.accountState.ss === "1" ||
        !hasVisibleApplicationTypes(),
      subgroups: [
        {
          title: "Высшее образование",
          links: [
            {
              path: "/applications/additional-high-data",
              text: "Дополнительные сведения",
            },
            {
              path: "/applications/high-education",
              text: "Заявления на поступление",
              isDisabled: !state.coreState.accountState?.user?.hasVO,
              hide: state.modulesState.applicationsState.additionalDataState.educationInfo
                .transferredFromAnotherUniversity,
            },
          ],
        },
        {
          title: "Дополнительное образование",
          links: [
            {
              path: "/applications/additional-ae-data",
              text: "Дополнительные сведения",
            },
            {
              path: "/applications/additional-education",
              text: "Заявления на поступление",
              isDisabled: !state.coreState.accountState?.user?.hasDPO,
            },
          ],
        },
        {
          title: "Аспирантура",
          links: [
            {
              path: "/applications/additional-postgraduate-data",
              text: "Дополнительные сведения",
            },
            {
              path: "/applications/postgraduate-education",
              text: "Заявления на поступление",
              isDisabled: !state.coreState.accountState?.user?.hasASP,
            },
          ],
        },
      ].filter(({ title }) => {
        if (title === "Высшее образование") {
          return isEducationTypeVisible("high");
        }
        if (title === "Дополнительное образование") {
          return isEducationTypeVisible("additional");
        }
        return isEducationTypeVisible("postgraduate");
      }),
    },
    {
      path: "/notifications",
      text: "Уведомления",
      isDisabled: !(
        hasCompletedVisibleNotificationApplications(
          state.coreState.accountState.hasCompletedHighEducationApplications,
          state.coreState.accountState.hasCompletedAdditionalEducationApplications,
          state.coreState.accountState.hasCompletedPostgraduateEducationApplications
        ) || examsExist
      ),
      isText: true,
      hide: !state.coreState.accountState.token,
      displaySubgroupsCondition: () =>
        hasCompletedVisibleNotificationApplications(
          state.coreState.accountState.hasCompletedHighEducationApplications,
          state.coreState.accountState.hasCompletedAdditionalEducationApplications,
          state.coreState.accountState.hasCompletedPostgraduateEducationApplications
        ) || examsExist,
      subgroups: [
        {
          links: [
            {
              path: "/notifications/high-education",
              text: "Высшее образование",
              additionalText: state.modulesState.notificationsState.info?.vpo?.count,
              isDisabled: !state.coreState.accountState.hasCompletedHighEducationApplications,
              hide: !isNotificationEducationTypeVisible("high"),
            },
            {
              path: `/notifications/${ENTRANCE_EXAMS_ROUTE_PATH}`,
              text: "Вступительные испытания",
              additionalText: state.modulesState.notificationsState.examsCount || undefined,
              hide: !examsExist,
            },
            {
              hide:
                !isNotificationEducationTypeVisible("additional") ||
                (state.coreState.accountState.ss === "1" &&
                  isNotificationEducationTypeVisible("high")),
              path: "/notifications/additional-education",
              text: "Дополнительное образование",
              additionalText: state.modulesState.notificationsState.info?.dpo?.count,
              isDisabled: !state.coreState.accountState.hasCompletedAdditionalEducationApplications,
            },
            // {
            //   path: "/notifications/postgraduate-education",
            //   text: "Аспирантура",
            //   additionalText: state.modulesState.notificationsState.info?.asp?.count,
            //   isDisabled:
            //     !state.coreState.accountState.hasCompletedPostgraduateEducationApplications,
            // },
          ],
        },
      ],
    },
  ];
};

export default getLinks;
